<template>
  <div v-loading="loading">
    <!--    <div class="flex justify-between items-center mb-16">-->
    <!--      <div class="title"> 欢迎使用，手机号密码登录 </div>-->
    <!--      <el-button-->
    <!--        type="primary"-->
    <!--        link-->
    <!--        @click="emit('changeLoginType', 'register')"-->
    <!--        >注册账号</el-button-->
    <!--      >-->
    <!--    </div>-->
    <el-form
      ref="ruleFormRef"
      style="max-width: 380px; margin: 0 auto"
      :model="ruleForm"
      :rules="rules"
      size="large"
    >
      <el-form-item prop="username">
        <div class="zhiyanger"> 登录账号：</div>
        <el-input
          v-model.trim="ruleForm.username"
          placeholder="请输入手机号码"
          size="large"
          autocomplete="off"
          maxlength="11"
          prefix-icon="iphone"
        />
      </el-form-item>
      <el-form-item prop="password">
        <div style="margin-top: -12px" class="zhiyanger"> 登录密码：</div>
        <el-input
          v-model.trim="ruleForm.password"
          type="password"
          show-password
          autocomplete="off"
          size="large"
          placeholder="请输入登录密码"
          maxlength="16"
          minlength="7"
          prefix-icon="Lock"
        />
      </el-form-item>
    </el-form>
    <div class="flex justify-between items-center mb-34">
      <el-button type="primary" link @click="RegisterAnAccount"
        >注册账号</el-button
      >
      <el-button type="primary" link @click="emit('changeLoginType', 'forget')"
        >忘记密码？</el-button
      >
    </div>
    <el-button
      class="w-full"
      color="#176EF7"
      type="primary"
      size="large"
      @click="submitForm(ruleFormRef)"
      >登录
    </el-button>
  </div>
</template>

<script setup>
import { isMobile, isPassword } from '@/utils/validate'
import { accountLoginApi } from '@/api/user'
import { useUserStore } from '@/store/modules/user'

const emit = defineEmits(['changeLoginType'])
const userStore = useUserStore()
const loading = ref(false)
const props = defineProps({
  type: {
    type: String,
    default: 'complex', // simplify 精简版 complex 复杂版
  },
})
const ruleFormRef = ref()
// 表单数据
const ruleForm = ref({
  username: '',
  password: '',
})
// 表单校验规则
const rules = {
  username: [
    {
      required: true,
      message: '请输入手机号码',
      trigger: 'blur',
    },
    {
      validator: (rule, value) => {
        return isMobile(value)
      },
      trigger: 'blur',
      message: '请输入正确的手机号码',
    },
  ],
  password: [
    {
      required: true,
      message: '请输入登录密码',
      trigger: 'blur',
    },
    {
      // validator: (rule, value) => {
      //   return isPassword(value)
      // },
      trigger: 'blur',
      message: '请输入7-16位登录密码',
    },
  ],
}

function RegisterAnAccount() {
  if (userStore.getShowLoginStatus) {
    emit('changeLoginType', 'register')
  } else {
    userStore.setShowLogin(true, 'register')
  }
}

function laliangs() {
  userStore.setShowLogin(true, 'forget')
}

// 登录
const submitForm = formEl => {
  if (!formEl) return
  formEl.validate(valid => {
    if (valid) {
      console.log('submit!', ruleForm.value)
      loading.value = true
      accountLoginApi(ruleForm.value)
        .then(res => {
          userStore.setToken(res.data.token)
          userStore.setShowLogin(false)
          loading.value = false
        })
        .catch(() => {
          loading.value = false
        })
    } else {
      return false
    }
  })
}
</script>

<style scoped lang="scss">
.zhiyanger {
  font-family: PingFangSC-regular;
  color: #9e9e9e;
  font-weight: 400;
  font-size: 15px;
}

.title {
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
  font-weight: bold;
}
</style>
